import { Navigate, Route, Routes } from 'react-router-dom';
import { SiteLayout } from '../layouts/SiteLayout';
import { AppDetailPage } from '../pages/AppDetailPage';
import { AppLegalPage } from '../pages/AppLegalPage';
import { AppsPage } from '../pages/AppsPage';
import { HomePage } from '../pages/HomePage';
import { LegalIndexPage } from '../pages/LegalIndexPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/apps" element={<AppsPage />} />
        <Route path="/apps/:appSlug" element={<AppDetailPage />} />
        <Route path="/apps/:appSlug/privacy" element={<AppLegalPage type="privacy" />} />
        <Route path="/apps/:appSlug/terms" element={<AppLegalPage type="terms" />} />
        <Route path="/privacy" element={<LegalIndexPage type="privacy" />} />
        <Route path="/terms" element={<LegalIndexPage type="terms" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
